import React from 'react';

import { useBreakpoints } from '$app/common/utils/mediaQueries';

const AccelerateBanner = () => {
  const { isSmDown } = useBreakpoints();

  return (
    <div
      css={{
        background:
          "url('https://images.snaphunt.com/assets/images/accelerate-banner.png')",
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        height: 352,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <span
        css={{
          textAlign: 'center',
          fontSize: isSmDown ? 24 : 46,
          fontWeight: 'bold',
          color: '#fff',
          maxWidth: 590,
          marginTop: isSmDown ? 30 : 75,
        }}
      >
        Accelerate your career with participating employers
      </span>
    </div>
  );
};

export default AccelerateBanner;
